// src/utils/analytics.js
import api from './api';

const SESSION_KEY = 'wawita_session_id';

function getSessionId() {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = 'sess_' + Date.now() + '_' + Math.random().toString(36).slice(2, 11);
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

const ORIGEN_KEY = 'wawita_origen';

function getOrigenData() {
  // Capturar UTMs y referrer una sola vez por sesion, persistidos en localStorage
  let stored = null;
  try { stored = JSON.parse(localStorage.getItem(ORIGEN_KEY) || 'null'); } catch (e) {}
  if (stored) return stored;

  const params = new URLSearchParams(window.location.search);
  const data = {
    referrer: document.referrer || null,
    utm_source: params.get('utm_source') || null,
    utm_medium: params.get('utm_medium') || null,
    utm_campaign: params.get('utm_campaign') || null,
  };
  try { localStorage.setItem(ORIGEN_KEY, JSON.stringify(data)); } catch (e) {}
  return data;
}

export function track(tipo, data = {}) {
  try {
    const origen = getOrigenData();
    api.post('/analytics/track', {
      session_id: getSessionId(),
      tipo,
      pagina: data.pagina,
      producto_id: data.producto_id,
      producto_nombre: data.producto_nombre,
      valor: data.valor,
      meta: data.meta,
      referrer: origen.referrer,
      utm_source: origen.utm_source,
      utm_medium: origen.utm_medium,
      utm_campaign: origen.utm_campaign,
    }).catch(() => {});
  } catch (e) {}
}
